<template>
  <div>
    <v-form v-model="valid" @submit.prevent="submit" ref="form">
      <v-text-field
        label="First Name"
        v-model="firstNames"
        :rules="rules.firstNames"
        required
        validate-on-blur
        type="text"
        :color="themes.candidate.light.input"
        ref="nameInput"
        @keypress.enter="submit"
        @input="fixCase"
      />
      <v-text-field
        label="Surname"
        v-model="lastName"
        :rules="rules.lastName"
        required
        type="text"
        :color="themes.candidate.light.input"
        @keypress.enter="submit"
        @input="fixCase"
      />
    </v-form>

    <div class="text-xs-right">
      <v-btn
        :color="themes.candidate.light.primaryActionButton"
        @click="submit"
        :disabled="!valid"
        type="submit"
      >
        That's me
      </v-btn>
    </div>
  </div>
</template>

<script>
// Components
import { mapGetters } from 'vuex'

// Mixins
import { caseConverters } from '@/mixins/caseConverters.js'

export default {
  mixins: [caseConverters],

  data() {
    return {
      // Models
      firstNames: '',
      lastName: '',
      // Validation
      valid: false,
      rules: {
        firstNames: [v => !!v || 'You must specify a first name'],
        lastName: [v => !!v || 'You must specify a last name'],
      },
    }
  },

  computed: mapGetters({ profile: 'candidate/profile/model' }),

  methods: {
    fixCase() {
      this.firstNames = this.toTitleCase(this.firstNames)
      this.lastName = this.toTitleCase(this.lastName)
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.$store.commit('candidate/profile/set', {
          ...this.profile,
          firstNames: this.firstNames,
          lastName: this.lastName,
        })
        this.$emit('done')
      }
    },
  },
}
</script>
